var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"id":"overlay","opacity":"0.35","absolute":true,"z-index":"51"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('overlay.help')))])])}
var staticRenderFns = []

export { render, staticRenderFns }